module.exports = __webpack_public_path__ + "static/board-26-e939dd02a37aae9f358a2a1135c392c7.jpg";